export interface PageSchemaContext {
  baseUrl: string
  pageUrl: string
  webpageId: string
}

export function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.replace(/\/$/, '')
}

export function createAbsoluteUrl(path: string, baseUrl: string): string {
  return new URL(path, `${normalizeBaseUrl(baseUrl)}/`).toString()
}

export function createPageSchemaContext(
  routePath: string,
  baseUrl: string,
): PageSchemaContext {
  const normalizedBaseUrl = normalizeBaseUrl(baseUrl)
  const pageUrl = createAbsoluteUrl(routePath, normalizedBaseUrl)

  return {
    baseUrl: normalizedBaseUrl,
    pageUrl,
    webpageId: `${pageUrl}#webpage`,
  }
}

export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function createWordCount(text?: string | null): number | undefined {
  if (!text) {
    return undefined
  }

  return text.split(/\s+/).filter(Boolean).length
}

export function createListItemElements(items: Array<{ '@id': string }>) {
  return items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: {
      '@id': item['@id'],
    },
  }))
}

export function createSeoMeta(
  title: string,
  description: string,
  pageUrl: string,
  imageUrl?: string,
) {
  return {
    title,
    description,
    ogTitle: title,
    ogDescription: description,
    ogUrl: pageUrl,
    ogImage: imageUrl,
    twitterCard: imageUrl ? 'summary_large_image' : 'summary',
  } as const
}

export function createLabOrganization(url: string) {
  return {
    '@type': 'Organization',
    name: 'Enterprise-of-Things Lab',
    url,
  }
}
